<template>
  <div class="plan-facts" v-if="facts">
    <span class="chip" :class="tissChipClass" v-if="facts.tiss && facts.tiss.enabled">
      <span class="chip-dot" v-if="!outdated"></span>
      <fa-icon :icon="['fal', 'exclamation-triangle']" v-else/>
      TISS {{ facts.tiss.version || '—' }}{{ outdated ? ' · desatualizado' : '' }}
    </span>
    <span class="chip" v-else>Sem TISS</span>
    <span class="chip">Limite {{ facts.limit }} guias/lote</span>
    <span class="chip" v-if="facts.paymentLabel">{{ facts.paymentLabel }}</span>
    <span class="chip" v-if="facts.allowMixed">Aceita lotes mistos</span>
  </div>
</template>

<script>
import { tissOutdated } from '../service';

export default {
  props: {
    facts: {
      type: Object,
      default: null,
    },
  },
  computed: {
    outdated() {
      return tissOutdated(this.facts && this.facts.tiss);
    },
    tissChipClass() {
      return this.outdated ? 'chip-amber' : 'chip-green';
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";
.plan-facts {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: .3rem;
}
</style>
